import {SingleTargetRelation} from '../SingleTargetRelation';
import {SketchRelationKind} from '../../relation-compatibility/SketchRelationKinds';

let count = 0;

/**
 * 圆-固定关系约束。
 */
export function isCircleFixConstraint(value: object): value is CircleFixConstraint {
    return Reflect.get(value, "isCircleFixConstraint") === true;
}
export class CircleFixConstraint extends SingleTargetRelation<any> {
    readonly isCircleFixConstraint: boolean = true;
    /**
     * 关系类型。
     */
    public relationType = SketchRelationKind.Fix;

    public constructor() {
        super();
        this.name = `${this.baseDisplayName}${count}`;
        count += 1;
    }

    public get baseDisplayName(): string {
        return '固定';
    }

}
